// Доступные скорости воспроизведения (меню скорости в контролах плеера)
export const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
